module.exports = __webpack_public_path__ + "img/np.c8a8ef36.svg";